// The last failed API call, so an `errors` event raised for it can carry an
// `error_code` (DAAM's WebEngage review). The axios response interceptor notes
// every failure here; the error event takes it if it is recent. Most UI errors
// are a `toast.error` a moment after the failed request, and the 115 toast
// call sites have no code of their own to pass.
//
// A failure is an HTTP error, or a 200 whose body says it failed
// (`success: "false"` / `data.status: false`), which several endpoints return.
// The backend's own code wins over the HTTP status; a 200 failure without one
// has no code to give.
//
// No imports on purpose: axios-config and the GTM events both read this leaf.
const MAX_AGE_MS = 5000;

let lastFailure = null;

// The backend's newer errors nest it: `{ error: { error_code, … } }`.
const getBodyCode = (body) => {
  const code =
    body?.error?.error_code ??
    body?.error_code ??
    body?.code ??
    body?.data?.error_code;
  return code === undefined || code === null || code === '' ? undefined : code;
};

export const isFailedBody = (body) =>
  body?.success === 'false' ||
  body?.success === false ||
  body?.data?.status === false;

// `fallback` names a failure with no HTTP status, such as a timeout.
export const noteApiFailure = ({ status, body, fallback }) => {
  if (typeof window !== 'object') return;
  const code =
    getBodyCode(body) ?? (status >= 400 ? status : undefined) ?? fallback;
  lastFailure = {
    at: Date.now(),
    ...(code !== undefined && { code: String(code) }),
  };
};

// Hands the failure to one error event only, so a later unrelated error does not
// inherit it.
export const takeRecentApiFailure = () => {
  const failure = lastFailure;
  lastFailure = null;
  return failure && Date.now() - failure.at <= MAX_AGE_MS ? failure : null;
};
